export const reviewItem = {
  finalReview: '',
  addendumReview: ''
};
